import { useAppSelector } from 'core/store/hooks';
import { setAllowTracking, setOnboardingQuestions, setSeenTutorial } from 'core/store/userSlice';
import { useDispatch } from 'react-redux';
import { putUserRequest } from 'utils/API/user';

export const useSettings = () => {
  const dispatch = useDispatch();
  const { allowTracking, seenTutorial, onboardingQuestions } = useAppSelector(
    (state) => state.user
  );

  const handleAllowTrackingChange = (newAllowTracking: boolean) => {
    dispatch(setAllowTracking(newAllowTracking));
    putUserRequest(newAllowTracking, seenTutorial, onboardingQuestions).catch((error) => {
      console.error('Error while adding allow tracking data to user data:', error);
    });
  };

  const handleSeenTutorialChange = (newSeenTutorial: boolean) => {
    dispatch(setSeenTutorial(newSeenTutorial));
    putUserRequest(allowTracking, newSeenTutorial, onboardingQuestions).catch((error) => {
      console.error('Error while adding seen tutorial data to user data:', error);
    });
  };

  const handleOnboardingQuestionsChange = (newOnboardingQuestions: OnboardingQuestion[]) => {
    dispatch(setOnboardingQuestions(newOnboardingQuestions));
    putUserRequest(allowTracking, seenTutorial, newOnboardingQuestions).catch((error) => {
      console.error('Error while adding onboarding questions data to user data:', error);
    });
  };

  const handleSettingsChange = (
    newAllowTracking: boolean,
    newSeenTutorial: boolean,
    newOnboardingQuestions: OnboardingQuestion[]
  ) => {
    dispatch(setAllowTracking(newAllowTracking));
    dispatch(setSeenTutorial(newSeenTutorial));
    dispatch(setOnboardingQuestions(newOnboardingQuestions));
    putUserRequest(newAllowTracking, newSeenTutorial, newOnboardingQuestions).catch((error) => {
      console.error('Error while adding data to user settings:', error);
    });
  };

  return {
    allowTracking,
    seenTutorial,
    onboardingQuestions,
    handleAllowTrackingChange,
    handleSeenTutorialChange,
    handleOnboardingQuestionsChange,
    handleSettingsChange,
  };
};

export default useSettings;
